// extracted by mini-css-extract-plugin
export default {"page":"MGPage_page__buzpe","mobileViewport":"MGPage_mobileViewport__yA1uw","body":"MGPage_body__I20a8","content":"MGPage_content__T9ehA"};